import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  wrapperContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: '1024px',
    padding: '0 16px',
  },

  linkIcon: {
    '&&': {
      width: 20,
      heigh: 20,
      color: theme.palette.custom.grey2,
    },
  },

  collapsedContent: {
    margin: SPACES.xxs,

    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.xs,
  },

  itemText: {
    '&&': {
      fontSize: '14px',
      width: 200,
      flex: '0 0 auto',
    },
  },

  row: {
    '&&': {
      border: 'unset',
    },
  },
  cell: {
    '&&': {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },

  image: {
    '&&': {
      display: 'block',

      borderRadius: 5,
      objectFit: 'cover',

      width: '80px',
      height: '80px',
      fill: theme.palette.custom.darkBlue2,
    },
  },

  map: {
    width: '100%',
    height: 400,
    borderRadius: 10,
    overflow: 'hidden',
  },

  copyIcon: {
    minWidth: 12,
    width: 12,
    height: 'auto',
  },

  transactionLink: {
    display: 'flex',
    gap: SPACES.xxxs,
    alignItems: 'center',

    wordBreak: 'break-all',
  },
  transactionLinkIcon: {
    minWidth: 16,
    width: 16,
    height: 'auto',
  },

  reasonModal: {
    '&&': {
      padding: SPACES.xxl,
      paddingTop: SPACES.xxxxxl,
      minWidth: '334px',
      maxWidth: '400px',
      width: '100%',
      minHeight: '300px',

      [theme.breakpoints.down('tablet')]: {
        minWidth: '290px',
        width: '90vw',
      },

      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      justifyContent: 'space-between',
    },
  },

  settingsModal: {
    '&&': {
      padding: SPACES.xxl,
      paddingTop: SPACES.xxxxxl,
      minWidth: '334px',
      maxWidth: '400px',
      width: '100%',
      minHeight: '260px',

      [theme.breakpoints.down('tablet')]: {
        minWidth: '290px',
        width: '90vw',
      },

      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      justifyContent: 'space-between',
    },
  },

  modalWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: SPACES.xxl,
    overflow: 'auto',

    minHeight: 360,
    maxHeight: '80vh',
    [theme.breakpoints.down('tablet')]: {
      width: 320,
    },
    [theme.breakpoints.up('tablet')]: {
      width: 400,
    },

    scrollbarColor: theme.palette.custom.grey2,
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.custom.grey2,
      borderRadius: '10px',
    },
  },

  title: {
    '&&': {
      fontSize: FONTS.SIZES.xl,
      fontWeight: FONTS.WEIGHTS.bold,
      marginBottom: SPACES.xl,

      textAlign: 'center',
    },
  },

  itemTitle: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,

      '&:first-letter': {
        textTransform: 'uppercase',
      },
    },
  },
  buttonsWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: SPACES.xl,
  },
  buttonWrapper: {
    width: '100%',
  },
  relationsTitle: {
    '&&': {
      fontSize: FONTS.SIZES.m,
    },
  },

  formSelect: {
    '&&': {
      paddingLeft: SPACES.xxl,
      paddingRight: SPACES.xl,

      border: `1px solid ${theme.palette.custom.grey}`,
      borderRadius: '30px',
      maxWidth: '100%',

      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.s,
      // textTransform: 'uppercase',
      color: theme.palette.custom.darkBlue2,

      [theme.breakpoints.down('laptop_l')]: {
        height: 34,
      },
      [theme.breakpoints.up('laptop_l')]: {
        height: 40,
      },
    },
  },

  selectionOptionsFormControl: {
    '&&': {
      maxWidth: '100%',
      width: '100%',
      [theme.breakpoints.down('laptop_l')]: {
        minWidth: 163,
      },
      [theme.breakpoints.up('laptop_l')]: {
        minWidth: 194,
      },
    },
  },
  selectMenu: {
    '&&': {
      maxHeight: 280,

      scrollbarWidth: 'thin',
      // scrollbarColor: `${theme.palette.custom.grey2} ${theme.palette.custom.grey2}`,
      '&::-webkit-scrollbar': {
        width: '3px',
      },
      '&::-webkit-scrollbar-track': {
        background: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        background: theme.palette.custom.grey2,
        borderRadius: '10px',
      },
    },
  },

  selectLabel: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.s,
      lineHeight: 1.33,
      textTransform: 'initial',

      color: theme.palette.custom.grey2,

      '&:first-letter': {
        textTransform: 'uppercase',
      },
    },
  },
}))
